import { useEffect } from "react";

export default function useGoogleAnalytics(measurementId?: string) {
  useEffect(() => {
    if (!measurementId) return;

    (window as any)[`ga-disable-${measurementId}`] = false;
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.body.appendChild(script);

    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${measurementId}');`;
    document.body.append(inlineScript);

    return () => {
      (window as any)[`ga-disable-${measurementId}`] = true;
      script.remove();
      inlineScript.remove();
    };
  }, [measurementId]);
}
